import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledSelectGenderArchetype = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 24px 24px 0;
    margin: 0 auto;
  `,
  Title: styled.p`
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 16px;
  `,
  Subtitle: styled.p`
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_BASE};

    & strong {
      font-weight: inherit;
      color: ${Color.GOLD_MEDIUM};
    }
  `,
  CardsContainer: styled.div`
    width: 100%;
    height: 295px;
    display: flex;
    gap: 12px;

    margin: 24px 0;
  `,
  Terms: styled.div`
    width: 100%;
    margin-top: auto;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 20px 0 24px;
  `,
}
